import { useEffect, useState } from "react";
import { fetchAuthConfig } from "../lib/api.js";
import type { SignupMode } from "../lib/signupCopy.js";

let pending: Promise<SignupMode | null> | null = null;

function loadSignupMode(): Promise<SignupMode | null> {
  if (!pending) {
    pending = fetchAuthConfig()
      .then((c) => c.signupMode)
      .catch(() => null);
  }
  return pending;
}

/** Live sign-up mode; fetched once per page load. `mode` is null until loaded (and on SSR). */
export function useSignupMode(): { mode: SignupMode | null; loaded: boolean } {
  const [state, setState] = useState<{ mode: SignupMode | null; loaded: boolean }>({
    mode: null,
    loaded: false,
  });
  useEffect(() => {
    let cancelled = false;
    void loadSignupMode().then((mode) => {
      if (!cancelled) setState({ mode, loaded: true });
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return state;
}
